import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const logoutUser = createAsyncThunk("logoutUser", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/oauth/logout-current/`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const logoutAllSessions = createAsyncThunk("logoutAllSessions", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/oauth/logout-all/`, {});
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});


export const LogoutSlice = createSlice({
    name: "Logout",
    initialState: {
        loading: false,
        error: null,
        success: false,
    },
    reducers: {
        resetLogout: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logoutUser.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        });
        builder.addCase(logoutUser.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        });
        builder.addCase(logoutUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.success = false;
        });
        builder.addCase(logoutAllSessions.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        });
        builder.addCase(logoutAllSessions.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        });
        builder.addCase(logoutAllSessions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.success = false;
        });
    },
});

export const { resetLogout } = LogoutSlice.actions;
export default LogoutSlice.reducer;
